import { WhatsAppOutlined } from "@ant-design/icons";
import { FloatButton } from "antd";
import { useLocation } from "react-router-dom";

const FloatingWhatsApp = () => {
  const location = useLocation();

  const handleClick = () => {
    const currentPath = location.pathname;
    const currentQuery = location.search;
    const fullUrl = `${window.location.origin}${currentPath}${currentQuery}`;

    let productName = null;

    let phoneNumber = "60122506616";

    if (/^\/product\/[^/]+/.test(currentPath)) {
      try {
        const stored = sessionStorage.getItem("lastViewedProduct");

        if (stored) {
          const parsed = JSON.parse(stored);

          productName = parsed?.ProductName || parsed?.productName || null;
        }
      } catch {}

      // fallback from slug
      if (!productName) {
        const segments = currentPath.split("/");

        if (segments[2]) {
          productName = segments[2]
            .split("-")
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" ");
        }
      }

      const message = `Hi, I would like to inquire about ${
        productName || "this product"
      }. Link: ${fullUrl}`;

      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        message,
      )}`;

      window.open(whatsappUrl, "_blank");
    } else {
      window.open(
        `https://wa.me/${phoneNumber}?text=Hi, I would like to inquire about your products.`,
        "_blank",
      );
    }
  };

  return (
    <FloatButton
      className="wa-float-btn"
      type="default"
      style={{
        right: 24,
        bottom: 24,
        height: 50,
        width: 50,
      }}
      icon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <WhatsAppOutlined style={{ color: "white", fontSize: 27 }} />
        </div>
      }
      onClick={handleClick}
    />
  );
};

export default FloatingWhatsApp;
